import { validateComment } from "./utils";

import { useField$Simple } from "@/modules/form-field/hooks/useField$Simple";

export const useField$Comment = useField$Simple.withConfig<string>({
  getInitialDraft: (params) => params.initialValue || "",
  normalizeDraft: (text) => text.trim(),
  validate: validateComment,
});
